<template>
  <div id="documentos" class="px-2">
      <v-tabs v-model="tab">
        <v-tab>Documentos do Emitente</v-tab>
        <v-tab>Documentos da Proposta</v-tab>
      </v-tabs>
      <v-tabs-items class="mt-4" v-model="tab">
        <v-tab-item><DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Pessoa" :codigoProposta="value.Codigo" :codigoPessoa="value.CodigoCliente" :documentoCliente="value.Cliente.DocumentoFederal"/></v-tab-item>
        <v-tab-item><DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Proposta" :codigoProposta="value.Codigo" /></v-tab-item>
      </v-tabs-items>
  </div>
</template>

<script>

export default {
  props: {
    value: null
  },
  data () {
    return {
      tab: 0
    }
  }
}
</script>
